/**
 * Converts a boolean to a Uint8Array.
 * True is encoded as 1, false as 0.
 *
 * @param value - The boolean to convert
 * @returns A Uint8Array with a single byte (0 or 1)
 *
 * @example
 * ```ts
 * import { BooleanToUint8, UInt8Hash } from "@pdfking/tfunc"
 *
 * BooleanToUint8(true) // Uint8Array([1])
 * BooleanToUint8(false) // Uint8Array([0])
 *
 * // Use for hashing
 * UInt8Hash([BooleanToUint8(true)])
 * ```
 */
export const BooleanToUint8 = (value: boolean): Uint8Array => new Uint8Array([value ? 1 : 0])
